import React from 'react'
import { Row, Column, View, SectionIntro } from 'components/Layout'
import { AppFeaturesOAuthClientForm } from '../../containers/Forms'

const AppAuthorization = ({ props, match }) => (
	<View>
		<Row topMargin>
			<Column width={6}>
				<SectionIntro header={'App Authorization'} />
			</Column>
		</Row>
		<Row>
			<Column width={6}>
				<AppFeaturesOAuthClientForm match={match} />
			</Column>
		</Row>
	</View>
)

export default AppAuthorization



// WEBPACK FOOTER //
// ./src/views/Apps/AppAuthorization.js